import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import Clipboard from 'clipboard';
import cx from 'classnames';
import { getSlugSuggestions, checkSlugAvailability } from '../../../../../../../actions/OnboardActions';
import { RenderField } from '../../../../../../common/form';
import SlugSuggestions from '../SlugSuggestions/SlugSuggestions';
import * as Validations from '../../../../../../common/form/commonValidations';
import './EditSlug.styles.less';

class EditSlug extends React.Component {
  state = {
    copyCta: 'Copy Url',
    copyLinkDisabled: false,
    clipboard: undefined,
    isClipboardSupported: Clipboard.isSupported()
  };

  componentDidMount() {
    this.fetchSlugSuggestions();
    this.initializeClipboard();
  }

  componentWillUnmount() {
    this.destroyClipboard();
  }

  initializeClipboard = () => {
    const clipboard = new Clipboard('#mpr-edit-slug__copy-text');

    clipboard.on('success', () => {
      this.setState({
        copyCta: 'Copied!',
        copyLinkDisabled: true
      });

      setTimeout(() => {
        this.setState({
          copyCta: 'Copy Url',
          copyLinkDisabled: false
        });
      }, 1500);
    });

    this.setState({ clipboard });
  }

  destroyClipboard = () => {
    const { clipboard } = this.state;

    if (clipboard) {
      clipboard.destroy();
    }

    this.setState({
      clipboard: undefined
    });
  }

  fetchSlugSuggestions = () => {
    const { handleGetSlugSuggestions, userContext } = this.props;
    const userData = userContext.user_role_account_weddings && userContext.user_role_account_weddings[0];
    const formattedDate = userData.wedding_date ? moment.utc(userData.wedding_date).toDate() : '';

    const slugSuggestionData = {
      primaryFirstName: userData.owner_first_name,
      partnerFirstName: userData.partner_first_name,
      primaryLastName: userData.owner_last_name,
      partnerLastName: userData.partner_last_name,
      eventDate: formattedDate
    };

    handleGetSlugSuggestions(slugSuggestionData).then(response => response.payload);
  }

  handleLiveUpdateSlug = (slug) => {
    this.props.liveUpdateSlug(slug);
    this.props.updateSlugForm(slug);
  }

  render() {
    const {
      handleSubmit,
      invalid,
      slugSuggestions,
      activeInput,
      toggleInput,
      updated,
      slug,
      published,
      asyncValidating
    } = this.props;


    const {
      copyCta,
      copyLinkDisabled,
      isClipboardSupported
    } = this.state;

    const editUrlCta = (
      <button
        key={2}
        className="mpr-edit-slug__text-button"
        onClick={toggleInput}
      >
        Edit Url
      </button>
    );


    return (
      <div className="mpr-edit-slug">
        <form onSubmit={handleSubmit}>
          <div className="mpr-edit-slug__url-prefix">www.zola.com/wedding/</div>
          <div className={cx('mpr-edit-slug__form-group', { 'mpr-edit-slug__form-group--active': activeInput })}>
            {activeInput ? (
              <React.Fragment>
                <div key={1} className="mpr-edit-slug__input">
                  <Field
                    name="mprSlug"
                    type="text"
                    component={RenderField}
                    maxChars={80}
                    autoComplete="off"
                    required
                    validate={[Validations.REQUIRED, Validations.MAX_LENGTH_20, Validations.SLUG]}
                    onChange={e => this.handleLiveUpdateSlug(e.target.value)}
                  />
                  <span
                    className={cx(
                      { 'zolaicon zolaicon-clear-field mpr-edit-slug__clear-icon': slug && !updated },
                      { 'zolaicon zolaicon-checkmark mpr-edit-slug__checkmark-icon': slug && updated }
                    )}
                    onClick={() => !updated && this.handleLiveUpdateSlug('')}
                  />
                </div>
                <button
                  key={2}
                  type="submit"
                  className={cx('mpr-edit-slug__text-button', 'mpr-edit-slug__save-button', { invalid })}
                  disabled={(asyncValidating || asyncValidating === 'true') || invalid || this.props.slug === this.props.originalSlug}
                >
                Save
                </button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div key={1} className="mpr-edit-slug__slug">
                  {slug}
                </div>
                {published && isClipboardSupported
                  ? (
                    <div className="mpr-edit-slug__actions">
                      {editUrlCta}
                      <button
                        id="mpr-edit-slug__copy-text"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                        className={cx(
                          'mpr-edit-slug__copy mpr-edit-slug__text-button',
                          { disabled: copyLinkDisabled }
                        )}
                        data-clipboard-text={`${window.location.host}/wedding/${slug}`}
                      >
                        {copyCta}
                      </button>
                    </div>
                  ) : (
                    <div className="mpr-edit-slug__actions">
                      {editUrlCta}
                    </div>
                  )
              }
              </React.Fragment>
            )}
          </div>
          {activeInput && <SlugSuggestions slugSuggestions={slugSuggestions} handleLiveUpdateSlug={this.handleLiveUpdateSlug} />}
        </form>
      </div>
    );
  }
}

EditSlug.propTypes = {
  userContext: PropTypes.shape({}),
  originalSlug: PropTypes.string,
  handleGetSlugSuggestions: PropTypes.func,
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  updateSlugForm: PropTypes.func,
  liveUpdateSlug: PropTypes.func,
  slugSuggestions: PropTypes.arrayOf(PropTypes.string),
  activeInput: PropTypes.bool,
  toggleInput: PropTypes.func,
  slug: PropTypes.string,
  updated: PropTypes.bool,
  published: PropTypes.bool,
  asyncValidating: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};


const mapStateToProps = state => ({
  published: state.wedding.account.published,
  slugSuggestions: state.Onboard.slugSuggestions,
  initialValues: {
    // this passes the state into redux-form
    mprSlug: state.user.userContext.user_role_account_weddings && state.user.userContext.user_role_account_weddings[0].slug,
  },
  // this allows state to be used as props in the component
  // slug: state.user.userContext.user_role_account_weddings && state.user.userContext.user_role_account_weddings[0].slug,
});

const mapDispatchToProps = dispatch => ({
  handleGetSlugSuggestions: slugSuggestionData => dispatch(getSlugSuggestions(slugSuggestionData)),
  updateSlugForm: (newSlug) => {
    dispatch(change('editSlugForm', 'mprSlug', newSlug));
  }
});

const asyncValidate = (values, dispatch, props) => {
  const { mprSlug } = values;
  const dirtySlug = mprSlug !== props.originalSlug;

  // don't check for suggestions if user enters their OG slug;
  return new Promise((resolve, reject) => {
    if (!dirtySlug) {
      return resolve();
    }

    return dispatch(checkSlugAvailability(mprSlug))
      .then((response) => {
        if (!response.payload) {
          const error = { mprSlug: 'This URL is already in use. Try another one.' };
          reject(error);
        }
        resolve();
      });
  });
};

const EditSlugForm = reduxForm({
  form: 'editSlugForm',
  destroyOnUnmount: false,
  asyncValidate,
  asyncBlurFields: ['mprSlug'],
  enableReinitialize: true
})(EditSlug);


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditSlugForm);



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/DropDownForms/UniqueUrlForm/EditSlug/EditSlug.jsx